import { Box } from '@hivewatch/dark'

import {
  VIDEO_WALL_COLS,
  VIDEO_WALL_ROWS,
  VIDEO_WALL_Z_INDEX,
} from '../../constants/constants'
import { SALES_VIDEO_WALL_CAMERAS } from '../../constants/salesCameras'
import { SalesVideoWallTile } from './SalesVideoWallTile'

/**
 * Sales-env fork of VideoWall (ENG-32238): the same full-screen 2x3 grid, but
 * seeded from a hardcoded camera list instead of the redux `cells` state. The
 * Sales env has no cloud cameras, so the normal picker would be empty — here
 * every cell is pre-filled and there is no add/remove. The persisted
 * `video-wall-v1` localStorage state is deliberately never read on this path.
 */
export const SalesVideoWall = () => (
  <Box
    bg='bg.app'
    bottom={0}
    data-testid='video_wall_overlay'
    display='grid'
    gap='12px'
    gridTemplateColumns={`repeat(${VIDEO_WALL_COLS}, 1fr)`}
    gridTemplateRows={`repeat(${VIDEO_WALL_ROWS}, 1fr)`}
    left={0}
    p='24px'
    position='fixed'
    right={0}
    top={0}
    zIndex={VIDEO_WALL_Z_INDEX}
  >
    {SALES_VIDEO_WALL_CAMERAS.map((camera) => (
      <SalesVideoWallTile camera={camera} key={camera.deviceId} />
    ))}
  </Box>
)
